import React, { createContext, useEffect, useState } from "react";
import {
  getReadingEmailAddress,
  getReadingEmailRestId,
  getReadingEmailSenderDisplayName,
  subscribeItemChanged,
} from "../taskpane";

const ReadingEmailContext = createContext<{
  emailId: string | null;
  emailAddress: string | null;
  senderDisplayName: string | null;
}>({
  emailId: null,
  emailAddress: null,
  senderDisplayName: null,
});

type Props = {
  children: React.ReactNode;
};

function ReadingEmailProvider({ children }: Props) {
  const [readingEmailInfo, setReadingEmailInfo] = useState(() => ({
    emailId: getReadingEmailRestId(),
    emailAddress: getReadingEmailAddress(),
    senderDisplayName: getReadingEmailSenderDisplayName(),
  }));

  useEffect(() => {
    return subscribeItemChanged(() => {
      setReadingEmailInfo({
        emailId: getReadingEmailRestId(),
        emailAddress: getReadingEmailAddress(),
        senderDisplayName: getReadingEmailSenderDisplayName(),
      });
    });
  }, []);

  return <ReadingEmailContext.Provider value={readingEmailInfo}>{children}</ReadingEmailContext.Provider>;
}

export { ReadingEmailProvider, ReadingEmailContext };
